var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGpsr2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9196 21H10.5185C6.9333 21 5.14068 21 4.02688 19.865C2.91309 18.7301 2.91309 16.9034 2.91309 13.25C2.91309 9.59661 2.91309 7.76992 4.02688 6.63496C5.14068 5.5 6.9333 5.5 10.5185 5.5H14.3213C17.9065 5.5 19.6992 5.5 20.813 6.63496C21.6699 7.50819 21.8675 8.7909 21.9131 11",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4131 22C20.8984 22 22.9131 19.9853 22.9131 17.5C22.9131 15.0147 20.8984 13 18.4131 13C15.9278 13 13.9131 15.0147 13.9131 17.5C13.9131 19.9853 15.9278 22 18.4131 22Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4131 18L19.8273 18.5541C19.1606 19.1847 18.8273 19.5 18.4131 19.5M18.4131 19.5C17.9989 19.5 17.6656 19.1847 16.9989 18.5541L16.4131 18M18.4131 19.5V15.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9131 5.5L16.8138 5.19094C16.3187 3.65089 16.0712 2.88087 15.482 2.44043C14.8927 2 14.1101 2 12.5447 2H12.2815C10.7161 2 9.93345 2 9.3442 2.44043C8.75495 2.88087 8.50745 3.65089 8.01243 5.19094L7.91309 5.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpsr2);
export default __webpack_public_path__ + "static/media/gpsr-2.c45f5e0b10d7c4b9757586d7a9111e6c.svg";
export { ForwardRef as ReactComponent };